import { create } from 'zustand';

export interface NotificationState {
  unreadCount: number;
  setUnreadCount: (count: number) => void;
  decrementCount: () => void;
  resetCount: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  unreadCount: 0,
  setUnreadCount: (count) => set({ unreadCount: count }),
  decrementCount: () =>
    set((state) => ({
      unreadCount: state.unreadCount > 0 ? state.unreadCount - 1 : 0,
    })),
  resetCount: () => set({ unreadCount: 0 }),
}));

